import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layaout',
  templateUrl: './layaout.component.html',
  styles: [
  ]
})
export class LayaoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
